import React, { Component } from 'react';

import '../css/locales.css'

import logolocales from '../img/sucursal-ico.svg'

class Locales extends Component {
  render() {
    return (
      <div className="container">

        <div className="locales row no-gutters">

          <div className="localestodo efectohover container col-6 col-lg-4">

            <div className="row no-gutters col p-3 p-lg-5">

              <div className="localescontenedor col-12 col-lg-4">
                <img className="logolocales" src={logolocales} alt=""/>
              </div>

              <div className="textolocalestodo container col-12 col-lg-8">
                <div className="row">

                  <div className="titulolocales col-12">
                    Sucursal 1
                  </div>

                  <div className="textolocales col-12">
                    <div className="lugar">Carcelén</div>
                    <div className="direccion">Diego de Vásquez N77-622 y Antonio Núñez</div>
                    <div className="telefono">2486-214</div>
                  </div>

                </div>
              </div>

            </div>

          </div>

          <div className="localestodo efectohover container col-6 col-lg-4">

            <div className="row no-gutters col p-3 p-lg-5">

              <div className="localescontenedor col-12 col-lg-4">
                <img className="logolocales" src={logolocales} alt=""/>
              </div>

              <div className="textolocalestodo container col-12 col-lg-8">
                <div className="row">

                  <div className="titulolocales col-12">
                    Sucursal 2
                  </div>

                  <div className="textolocales col-12">
                    <div className="lugar">San Luis de Calderón</div>
                    <div className="direccion">Geovanny Calles OE6-26 y Palermo</div>
                    <div className="telefono">2826-870 / 2826-871</div>
                  </div>

                </div>
              </div>

            </div>

          </div>

          <div className="localestodo efectohover container col-6 col-lg-4">

            <div className="row no-gutters col p-3 p-lg-5">

              <div className="localescontenedor col-12 col-lg-4">
                <img className="logolocales" src={logolocales} alt=""/>
              </div>

              <div className="textolocalestodo container col-12 col-lg-8">
                <div className="row">

                  <div className="titulolocales col-12">
                    Sucursal 3
                  </div>

                  <div className="textolocales col-12">
                    <div className="lugar">San José de Morán</div>
                    <div className="direccion">Carlos Mantilla OE4-23 y Río de Janeiro</div>
                    <div className="telefono">2032-721 / 2032-041</div>
                  </div>

                </div>
              </div>

            </div>

          </div>

          <div className="localestodo efectohover container col-6 col-lg-4 no-gutters">

            <div className="row no-gutters col p-3 p-lg-5">

              <div className="localescontenedor col-12 col-lg-4">
                <img className="logolocales" src={logolocales} alt=""/>
              </div>

              <div className="textolocalestodo container col-12 col-lg-8">
                <div className="row">

                  <div className="titulolocales col-12">
                    Sucursal 4
                  </div>

                  <div className="textolocales col-12">
                    <div className="lugar">Marianitas de Jesús</div>
                    <div className="direccion">Amalia Uriguen s/n y Francisco Albornóz</div>
                    <div className="telefono">2036-560 / 2036-771</div>
                  </div>

                </div>
              </div>

            </div>

          </div>

          <div className="localestodo efectohover container col-6 col-lg-4 no-gutters">

            <div className="row no-gutters col p-3 p-lg-5">

              <div className="localescontenedor col-12 col-lg-4">
                <img className="logolocales" src={logolocales} alt=""/>
              </div>

              <div className="textolocalestodo container col-12 col-lg-8">
                <div className="row">

                  <div className="titulolocales col-12">
                    Sucursal 5
                  </div>

                  <div className="textolocales col-12">
                    <div className="lugar">Carcelén</div>
                    <div className="direccion">Alejandro Ponce y Clemente Yerovi</div>
                    <div className="telefono">2473-576</div>
                  </div>

                </div>
              </div>

            </div>

          </div>

        </div>

      </div>
    )
  }
}

export default Locales;
